import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { UserInfoInput } from './fields/UserInfoInput';
import { DurationPicker } from './fields/DurationPicker';

export const UserInfoInputFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'UserInfoInput',
    component: UserInfoInput,
  })
);

export const DurationPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DurationPicker',
    component: DurationPicker,
  })
);